/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NumberedListIcon = /*#__PURE__*/ createSvgIcon(
  'NumberedListIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.04 10.5h7v1h-7v-1zM7.04 4.5h7v1h-7v-1z"
            fill="currentColor"
          />
          <path
            d="M3.07 6.88V3.55h-.86v-.74h1.6v4.07h-.74z"
            fill="currentColor"
          />
          <path
            d="M3.68 2.94v3.81H3.2V3.42h-.87v-.48h1.35zm-1.6-.25v1H3V7h1V2.69H2.08zM2.09 13.19v-.8l1.3-1.08c.54-.4.54-.69.54-.83a.68.68 0 00-.74-.62.84.84 0 00-.62.31l-.44-.44a1.61 1.61 0 011.31-.61 1.36 1.36 0 011.4.9 1.43 1.43 0 01-.61 1.59l-1.18.84h1.87v.74H2.09z"
            fill="currentColor"
          />
          <path
            d="M3.44 9.25a1.23 1.23 0 011.28.8 1.32 1.32 0 01-.56 1.46l-.87.61-.63.46h2.13v.48H2.21v-.61l1.26-1c.52-.39.59-.7.59-.94a.81.81 0 00-.87-.74 1 1 0 00-.62.25l-.27-.3a1.51 1.51 0 011.14-.47zm0-.25A1.76 1.76 0 002 9.74l.62.62a.83.83 0 01.57-.36.56.56 0 01.62.49c0 .12 0 .37-.49.74L2 12.33v1h3v-1H3.44l.86-.62A1.45 1.45 0 003.44 9z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15.5h10v1H8v-1zM8 9.5h10v1H8v-1zM8 3.5h10v1H8v-1z"
            fill="currentColor"
          />
          <path
            d="M3.83 2v4h-.92V2.91h-.8V2h1.72zM4.06 15.49l.8-.58V14H2.11v.91h1.38l-.69.58v.8h.91a.49.49 0 01.46.45.49.49 0 01-.46.46h-.45a.82.82 0 01-.69-.34l-.57.68c.442.294.96.454 1.49.46 1 0 1.6-.57 1.6-1.37a1 1 0 00-1.03-1.14zM4.17 10.23a1.35 1.35 0 00-.8-2.52A1.62 1.62 0 002 8.4l.57.6a.79.79 0 01.57-.34.52.52 0 01.57.46c0 .11 0 .34-.45.68L2 10.8v.91h2.86v-.91H3.37l.8-.57z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 19h13v1H9v-1zM9 11.5h13v1H9v-1zM9 4h13v1H9V4z"
            fill="currentColor"
          />
          <path
            d="M4 2H2.12v1H3v3.31h1V2zM3.48 9.54c-.283-.015-.566.089-.824.207A1.75 1.75 0 002 10.27l.62.62a.83.83 0 01.61-.37.57.57 0 01.62.49c0 .13 0 .37-.49.74L2 12.86v1h3.08v-1h-1.6l.86-.61c.28-.205.521-.42.645-.732a1.45 1.45 0 00-.556-1.752c-.28-.182-.611-.226-.949-.226zM2.08 17.69h3v.98l-.86.62c.158-.008.316.02.463.08.151.081.657.286.657 1.24 0 .796-.63 1.453-1.74 1.453-.569-.01-1.123-.137-1.52-.657l.54-.606a.89.89 0 00.324.276c.13.065.396.094.656.094s.47-.003.614-.146a.5.5 0 00-.354-.854h-1v-.86l.74-.62H2.08v-1z"
            fill="currentColor"
          />
        </>
      ),
    },
    rtl: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.96 10.5h7v1h-7v-1zM1.96 4.5h7v1h-7v-1z"
            fill="currentColor"
          />
          <path
            d="M12.07 6.88V3.55h-.86v-.74h1.6v4.07h-.74z"
            fill="currentColor"
          />
          <path
            d="M12.68 2.94v3.81h-.48V3.42h-.87v-.48h1.35zm-1.6-.25v1H12V7h1V2.69h-1.92zM11.09 13.19v-.8l1.3-1.08c.54-.4.54-.69.54-.83a.68.68 0 00-.74-.62.84.84 0 00-.62.31l-.44-.44a1.61 1.61 0 011.31-.61 1.36 1.36 0 011.4.9 1.43 1.43 0 01-.61 1.59l-1.18.84h1.87v.74h-2.83z"
            fill="currentColor"
          />
          <path
            d="M12.44 9.25a1.23 1.23 0 011.28.8 1.32 1.32 0 01-.56 1.46l-.87.61-.63.46h2.13v.48h-2.58v-.61l1.26-1c.52-.39.59-.7.59-.94a.81.81 0 00-.87-.74 1 1 0 00-.62.25l-.27-.27a1.51 1.51 0 011.14-.47v-.03zm0-.22a1.76 1.76 0 00-1.44.71l.62.62a.83.83 0 01.61-.37.56.56 0 01.62.49c0 .12 0 .37-.49.74L11 12.33v1h3v-1h-1.6l.86-.62A1.45 1.45 0 0012.44 9v.03z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 15.5h10v1H2v-1zM2 9.5h10v1H2v-1zM2 3.5h10v1H2v-1z"
            fill="currentColor"
          />
          <path
            d="M16.73 2v4h-.91V2.91H15V2h1.73zM17 15.49l.8-.58V14H15v.91h1.37l-.69.58v.8h.92a.48.48 0 01.45.45.49.49 0 01-.45.46h-.46a.82.82 0 01-.69-.34l-.57.68c.442.294.96.454 1.49.46 1 0 1.6-.57 1.6-1.37a1 1 0 00-.97-1.14zM17.07 10.23a1.35 1.35 0 00-.8-2.52 1.63 1.63 0 00-1.37.69l.57.57a.8.8 0 01.58-.34.52.52 0 01.57.46c0 .11 0 .34-.46.68l-1.26 1v.91h2.86v-.88h-1.49l.8-.57z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 19h13v1H2v-1zM2 11.5h13v1H2v-1zM2 4h13v1H2V4z"
            fill="currentColor"
          />
          <path
            d="M20.642 2h-1.88v1h.88v3.31h1V2zM20.122 9.54c-.283-.015-.566.089-.824.207a1.75 1.75 0 00-.656.523l.62.62a.83.83 0 01.61-.37.57.57 0 01.62.49c0 .13 0 .37-.49.74l-1.36 1.11v1h3.08v-1h-1.6l.86-.61c.28-.205.521-.42.645-.732a1.45 1.45 0 00-.556-1.752c-.28-.182-.611-.226-.949-.226zM18.722 17.69h3v.98l-.86.62c.159-.008.317.02.463.08.152.081.657.286.657 1.24 0 .796-.63 1.453-1.74 1.453-.568-.01-1.123-.137-1.52-.657l.54-.606a.89.89 0 00.325.276c.129.065.395.094.655.094s.47-.003.614-.146a.5.5 0 00-.354-.854h-1v-.86l.74-.62h-1.52v-1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default NumberedListIcon;
